import { type ReactNode } from "react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "@/core/auth/msalInstance";

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    // Initialization is handled in main.tsx before this component mounts
    return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};
